import React from "react";
import {
    PieChart, Pie, Cell,
    ResponsiveContainer, Legend, Tooltip,
} from "recharts";
import Firebase from "../../Firebase";
import {useListVals} from "react-firebase-hooks/database";
import distinctColors from 'distinct-colors'
import {useCollection} from "react-firebase-hooks/firestore";


const db = Firebase.firestore();
const QuantitySold = (props) => {

    var moment = require('moment');

    const [dataArray, setDataArray] = React.useState([]);
    const [products] = useCollection(
        db.collection('products'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        });
    const [sales] = useCollection(
        db.collection('sales'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        });
    const [weekdays, setWeekDays] = React.useState([]);
    const [labelArray, setLabelArray] = React.useState([]);
    const [loading , setLoading] = React.useState(false);
    const [paletteArray, setPaletteArray] = React.useState([]);

    var todayNum = moment().isoWeekday();
    //var lastWeekToday = todayNum - 14;

    const getSum = (weekArray, saleArray) => {
        var sum = 0

        weekArray.map((weekday) => {
            var filtered = saleArray.filter(x => (moment(x.updatedAt, "YYYY-MM-DD h:mm:SSS").format("YYYY-MM-DD") === weekday.date));
            filtered.map((item) => {
                sum = sum + parseInt(item.quantity);
            });
        });

        return sum;
    }

    React.useEffect(() => {

        //setLoading(true);

        var number;
        if(props.period === "Last 7 days"){
            number = 7;
        }else if(props.period === "Last 30 days"){
            number = 30;
        } else {
            number = 90;
        }

        //console.log(props.period);

        var weekArray = [];
        var labelArray = [];

        for(var i=0; i < number; i++){
            weekArray.push({"date" : moment().weekday(todayNum - i).format("YYYY-MM-DD"),
                "name" : moment().weekday(todayNum - i).format('DD/MM')});
            labelArray.push(moment().weekday(todayNum - i).format('DD/MM'))
        }

        setLabelArray(labelArray);
        setWeekDays(weekArray);
        
        if(sales){
            var salesArray = []
            sales.docs.map((item) => {
                salesArray.push(item.data());
            })
            
            var tempArray = []
            if(number === 7){

                var sum = getSum(weekArray, salesArray);
                console.log(sum);
                tempArray.push({"name" : "This week", "count" : sum});

            } else if(number === 30){
                var thisWeekArray = []; var lastWeekArray=[]; var last2WeeksArray= []; var last3WeeksArray = [];
                for(var j=0; j<7; j++){
                    thisWeekArray.push(weekArray[j]);
                }
                for(var m=7; m<15; m++){
                    lastWeekArray.push(weekArray[m]);
                }
                for(var n=15; n<23; n++){
                    last2WeeksArray.push(weekArray[n]);
                }
                for(var x=23; x<30; x++){
                    last3WeeksArray.push(weekArray[x]);
                }
                //console.log(thisWeekArray, lastWeekArray, last2WeeksArray, last3WeeksArray);

                var thisWeek = {"name" : "This Week", "count" : getSum(thisWeekArray, salesArray)};
                var lastWeek = {"name" : "Last Week", "count" : getSum(lastWeekArray, salesArray)};
                var last2Weeks = {"name" : "Last 2 Weeks", "count" : getSum(last2WeeksArray, salesArray)};
                var last3Weeks = {"name" : "Last 3 Weeks", "count" : getSum(last3WeeksArray, salesArray)};

                tempArray.push(thisWeek, lastWeek, last2Weeks, last3Weeks);

            }

            //console.log(tempArray);
            var palette = distinctColors({count: tempArray.length});
            setPaletteArray(palette);
            setDataArray([...tempArray]);
        }





    }, [ moment, products, props, sales, todayNum]);


    return (
        <ResponsiveContainer height={400} className="d-flex justify-content-center text-center">
            {dataArray.length === 0 ?
                loading ? <div className="spinner-border text-center ml-2 indigo-text spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div> : <div className="text-center">No data to show</div>
                :
                <PieChart>
                    <Legend />
                    <Tooltip />

                    <Pie data={dataArray} dataKey="count" nameKey="name" legendType="circle">
                        {
                            dataArray.map((color, index) => <Cell key={`cell-${index}`} fill={paletteArray[index]} />)
                        }
                    </Pie>

                </PieChart>}
        </ResponsiveContainer>
    );
}

export default QuantitySold;
